export default __webpack_public_path__ + "static/media/star.74f14e15.jpg";